import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isAppApiRequest } from './is-app-api-request';

@Injectable()
export class RequestHeaderInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Never copy the caller's token onto a request to someone else's host
    if (req.headers.has('Authorization') && isAppApiRequest(req.url)) {
      const modifiedReq = req.clone({
        setHeaders: {
          'X-Original-Token': req.headers.get('Authorization') || ''
        }
      });

      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
